export interface IAccrual {
    Id: string
    Name: string
    Code: string
    ContributingRatePerHour: number
    DeductionRatePerHour: number
    ContributingPayTypeIds: string[]
    AllowUseForLeaveTracking: boolean
    RequireNoteOnTimeOffApproval:boolean
    PayTypeIdUsedForLeavePunchSet: string
    ExternalId?: string
    AccountId: string
    Deleted: boolean
    MinBalance: number
    MaxBalance: number
    MinHoursPerDay?: number
    MaxHoursPerDay?: number
    Type: EAccrualType
}

export enum EAccrualType {
    PerHourWorked,
    PerDay,
    Monetary,
}